import { useState, useCallback, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const API_BASE_URL =
  "https://dev.oliveeb.com/payment-service/api/v1/payments/methods";

export default function usePaymentMethods(userId) {
  const authToken = sessionStorage.getItem("authToken");
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // handle axios errors
  const handleAxiosErrors = (err, action = "operation") => {
    let message = "An unexpected error occurred.";
    if (err.response) {
      message =
        err.response.data?.message ||
        `Failed to ${action}: ${err.response.statusText}`;
    } else if (err.request) {
      message =
        "No response from the server. Please check your internet connection.";
    } else {
      message = err.message || "Something went wrong.";
    }
    setError(message);
    toast.error(message);
    console.error(`${action} error:`, err);
  };

  // Fetch all payment methods
  const fetchPaymentMethods = useCallback(async () => {
    setLoading(true);
    setError(null);
    if (!userId) return;
    try {
      const pageSize = 50;
      const firstResponse = await axios.get(
        `${API_BASE_URL}?uid=${userId}&page=0&size=${pageSize}`,
        {
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );

      const { content: firstContent = [], totalPages = 1 } = firstResponse.data;
      let allPaymentMethods = [...firstContent];

      if (totalPages > 1) {
        const promises = [];
        for (let p = 1; p < totalPages; p++) {
          promises.push(
            axios.get(`${API_BASE_URL}?uid=${userId}&page=0&size=${pageSize}`, {
              headers: { Authorization: `Bearer ${authToken}` },
            })
          );
        }

        const responses = await Promise.all(promises);
        responses.forEach((res) => {
          allPaymentMethods = allPaymentMethods.concat(res.data.content || []);
        });
      }

      setPaymentMethods(allPaymentMethods);
    } catch (err) {
      handleAxiosErrors(err, "Fetch donations");
    } finally {
      setLoading(false);
    }
  }, [authToken]);

  // Fetch one donation by ID
  //   const fetchPaymentMethodById = useCallback(
  //     async (id) => {
  //       setLoading(true);
  //       setError(null);
  //       try {
  //         const res = await axios.get(`${API_BASE_URL}/${id}`, {
  //           headers: { Authorization: `Bearer ${authToken}` },
  //         });
  //         setSelectedDonation(res.data);
  //         return res.data;
  //       } catch (err) {
  //         handleAxiosErrors(err, "fetch donation details");
  //         throw err;
  //       } finally {
  //         setLoading(false);
  //       }
  //     },
  //     [authToken]
  //   );

  // fetch automatically on mount
  useEffect(() => {
    if (authToken) fetchPaymentMethods();
  }, [authToken, fetchPaymentMethods]);

  return {
    paymentMethods,
    loading,
    error,
    fetchPaymentMethods,
    // fetchPaymentMethodById,
  };
}
